import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';

import FormFooter from '../form-footer';
import ModalSplitForm from '../../containers/modal-split-form.container';
import ClaimPurchaseSummary from '../purchase-claim/claim-purchase-summary';
import renderConsumerField from '../render-consumer-field';

import validate from './validate';

import '../../css/purchase-consumer-fields.css';

class PurchaseConsumerFields extends Component {
  renderFields() {
    return this.props.consumerFieldSchemas.map((field, index) => {
      const key = `field-${index}`;
      return renderConsumerField({ ...field, key })
    });
  }

  renderForm() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div className="purchase-consumer-fields justify-content-center">
        <form onSubmit={handleSubmit(this.props.onSubmit)}>

          <h3 className="mb-3">
            <FormattedMessage
              id="purchaseFields.title"
              defaultMessage="Customize your purchase"
            />
          </h3>
          <p className="cool-grey mb-4">
            <FormattedMessage
              id="purchaseFields.description"
              defaultMessage="This information will apply for the whole purchase,
                and only you (the organizer) can modify it."
            />
          </p>

          <div className='consumer-field-schemas-container'>
            { this.renderFields() }
          </div>

          <FormFooter height="short">
            <div className="col-12">

              <button
                type="submit"
                className="btn btn-primary pull-right"
                disabled={submitting}
              >
                <FormattedMessage
                  id="purchaseFields.submit"
                  defaultMessage="Save"
                />
              </button>
            </div>
          </FormFooter>
        </form>
      </div>
    );
  }

  render() {
    return (
      <div>
        <ModalSplitForm
          leftForm={this.renderForm()}
          rightForm={<ClaimPurchaseSummary />}
        />
      </div>
    );
  }
}

export default injectIntl(reduxForm({
  form: 'purchaseConsumerFields',
  validate,
})(PurchaseConsumerFields));



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-consumer-fields/index.js